import { render, staticRenderFns } from "./AllergyInfoItem.vue?vue&type=template&id=2ce185bc&"
import script from "./AllergyInfoItem.vue?vue&type=script&lang=js&"
export * from "./AllergyInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports